(function () {
  'use strict';

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function norm(str) {
    return (str || '').toLowerCase().replace(/-/g, ' ').trim();
  }

  var SHAPE_VALUES = [
    'round','baguette','heart','oval','cushion','emerald',
    'pear','asscher','square','marquise','princess','radiant'
  ];

  function isShape(text) {
    return SHAPE_VALUES.indexOf(norm(text)) !== -1;
  }

  // ─── Slide show/hide ────────────────────────────────────────────────────────

  function hideSlide($slide) {
    $slide.css({
      position: 'absolute',
      visibility: 'hidden',
      'z-index': '-1',
      'pointer-events': 'none'
    });
  }

  function showSlide($slide) {
    $slide.css({
      position: '',
      visibility: '',
      'z-index': '',
      'pointer-events': ''
    });
  }

  // ─── Core filter ────────────────────────────────────────────────────────────

  function applyFilter(sectionId, matchFn) {
    if (!sectionId || typeof jQuery === 'undefined') return;

    var $photos = jQuery('#ProductPhotos-' + sectionId);
    var $thumbs = jQuery('#ProductThumbs-' + sectionId);
    if (!$photos.length) return;

    var $allSlides = $photos.find('.slick-slide:not(.slick-cloned)');
    var $allThumbs = $thumbs.find('.slick-slide:not(.slick-cloned)');

    var firstIdx = -1;
    $allSlides.each(function () {
      var alt = norm(jQuery(this).attr('data-alt') || '');
      if (matchFn(alt) && firstIdx === -1) {
        firstIdx = parseInt(jQuery(this).attr('data-slick-index'), 10);
      }
    });

    if (firstIdx === -1) return;

    if ($photos.hasClass('slick-initialized')) $photos.slick('slickGoTo', firstIdx, true);
    if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('slickGoTo', firstIdx, true);

    setTimeout(function () {
      $allSlides.each(function () {
        var $s = jQuery(this);
        matchFn(norm($s.attr('data-alt') || '')) ? showSlide($s) : hideSlide($s);
      });
      $allThumbs.each(function () {
        var $t = jQuery(this);
        matchFn(norm($t.attr('data-alt') || '')) ? showSlide($t) : hideSlide($t);
      });

      if ($photos.hasClass('slick-initialized')) $photos.slick('setPosition');
      if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('setPosition');

      $thumbs.find('.product__thumb').removeClass('is-active');
      $allThumbs.each(function () {
        var $t = jQuery(this);
        if (matchFn(norm($t.attr('data-alt') || ''))) {
          $t.find('.product__thumb').addClass('is-active');
          return false;
        }
      });
    }, 50);
  }

  function showAll(sectionId) {
    if (!sectionId || typeof jQuery === 'undefined') return;
    var $photos = jQuery('#ProductPhotos-' + sectionId);
    var $thumbs = jQuery('#ProductThumbs-' + sectionId);
    $photos.find('.slick-slide').each(function () { showSlide(jQuery(this)); });
    $thumbs.find('.slick-slide').each(function () { showSlide(jQuery(this)); });
    if ($photos.hasClass('slick-initialized')) { $photos.slick('slickGoTo', 0, true); $photos.slick('setPosition'); }
    if ($thumbs.hasClass('slick-initialized')) { $thumbs.slick('slickGoTo', 0, true); $thumbs.slick('setPosition'); }
  }

  // ─── MODE 1 : COLOR only ────────────────────────────────────────────────────
  // Color swatch click → sirf color name se filter
  // Alt text example: "yellow gold"  /  "platinum"  /  "rose gold"

  function filterByColor(sectionId, colorText) {
    var color = norm(colorText);
    applyFilter(sectionId, function (alt) {
      return alt === color || alt.indexOf(color) !== -1;
    });
  }

  // ─── MODE 2 : METAL + SHAPE combined ───────────────────────────────────────
  // Metal Type ya Shape koi bhi change ho → dono ka combination filter karo
  // Alt text example: "14k white gold cushion"  /  "platinum round"

  function getSelectedMetalAndShape(sectionId) {
    var metal = null;
    var shape = null;

    document.querySelectorAll(
      'label.variant__button-label[data-section-id="' + sectionId + '"]'
    ).forEach(function (lbl) {
      var inp = document.getElementById(lbl.getAttribute('for'));
      if (!inp || !inp.checked) return;
      var txt = lbl.textContent.trim();
      if (!lbl.classList.contains('color-swatch') && !isShape(txt)) {
        metal = norm(txt);
      }
    });

    document.querySelectorAll('input.variant__input-' + sectionId).forEach(function (inp) {
      if (!inp.checked) return;
      if (isShape(inp.value)) shape = norm(inp.value);
    });

    return { metal: metal, shape: shape };
  }

  function filterByMetalAndShape(sectionId) {
    var combo = getSelectedMetalAndShape(sectionId);
    if (!combo.metal && !combo.shape) { showAll(sectionId); return; }

    applyFilter(sectionId, function (alt) {
      var metalOk = combo.metal ? alt.indexOf(combo.metal) !== -1 : true;
      var shapeOk = combo.shape ? alt.indexOf(combo.shape) !== -1 : true;
      return metalOk && shapeOk;
    });
  }

  // ─── Icon highlight (Feldsteins circle style) ───────────────────────────────

  function updateCheckedStyles() {
    document.querySelectorAll('label.metal-type-label.is-selected').forEach(function (l) {
      l.classList.remove('is-selected');
    });
    document.querySelectorAll('input.AAA').forEach(function (inp) {
      if (!inp.checked) return;
      var lbl = document.querySelector('label[for="' + inp.id + '"]');
      if (lbl && lbl.classList.contains('metal-type-label')) {
        lbl.classList.add('is-selected');
      }
    });
  }

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function getSectionIdFromInput(input) {
    if (!input) return null;
    var cls = Array.from(input.classList).find(function (c) {
      return c.startsWith('variant__input-') && c.length > 'variant__input-'.length;
    });
    return cls ? cls.replace('variant__input-', '') : null;
  }

  // ─── Page load ──────────────────────────────────────────────────────────────

  function applyOnLoad() {
    var sectionIds = new Set();
    document.querySelectorAll('label[data-section-id]').forEach(function (l) {
      sectionIds.add(l.getAttribute('data-section-id'));
    });
    document.querySelectorAll('input.AAA').forEach(function (inp) {
      var sid = getSectionIdFromInput(inp);
      if (sid) sectionIds.add(sid);
    });

    sectionIds.forEach(function (sid) {
      // Check: kya is section mein color-swatch hai?
      var checkedColor = null;
      document.querySelectorAll('label.color-swatch[data-section-id="' + sid + '"]').forEach(function (lbl) {
        var inp = document.getElementById(lbl.getAttribute('for'));
        if (inp && inp.checked) checkedColor = lbl.textContent.trim();
      });

      if (checkedColor) {
        // COLOR wala product — sirf color se filter
        filterByColor(sid, checkedColor);
      } else {
        // METAL + SHAPE wala product
        filterByMetalAndShape(sid);
      }
    });

    updateCheckedStyles();
  }

  // ─── Event listeners ────────────────────────────────────────────────────────

  function init() {
    document.addEventListener('click', function (e) {

      // ── COLOR swatch ──────────────────────────────────────────────────────────
      // Sirf color name se filter karo — metal/shape se independent
      var colorLabel = e.target.closest('label.color-swatch[data-section-id]');
      if (colorLabel) {
        var colorSid = colorLabel.getAttribute('data-section-id');
        var colorText = colorLabel.textContent.trim();
        setTimeout(function () {
          filterByColor(colorSid, colorText);
        }, 10);
        return;
      }

      // ── METAL TYPE ────────────────────────────────────────────────────────────
      // Metal + Shape combination se filter karo
      var metalLabel = e.target.closest('label.variant__button-label[data-section-id]');
      if (metalLabel && !metalLabel.classList.contains('color-swatch')) {
        var metalSid = metalLabel.getAttribute('data-section-id');
        setTimeout(function () {
          filterByMetalAndShape(metalSid);
          updateCheckedStyles();
        }, 10);
        return;
      }

      // ── SHAPE ─────────────────────────────────────────────────────────────────
      // Shape click → Metal + Shape combination se filter karo
      var shapeLabel = e.target.closest('label.metal-type-label');
      if (shapeLabel && !shapeLabel.getAttribute('data-section-id')) {
        var shapeInp = document.getElementById(shapeLabel.getAttribute('for'));
        var shapeSid = getSectionIdFromInput(shapeInp);
        if (shapeSid) {
          setTimeout(function () {
            filterByMetalAndShape(shapeSid);
            updateCheckedStyles();
          }, 10);
        }
        return;
      }

      // ── Other / custom ────────────────────────────────────────────────────────
      var customLabel = e.target.closest('label.custom_var[data-section-id]');
      if (customLabel) {
        showAll(customLabel.getAttribute('data-section-id'));
      }
    });

    applyOnLoad();
  }

  // ─── Wait for Slick ──────────────────────────────────────────────────────────

  function waitForSlick() {
    if (typeof jQuery === 'undefined') { setTimeout(waitForSlick, 200); return; }
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (jQuery('[id^="ProductPhotos-"]').hasClass('slick-initialized')) {
        clearInterval(iv); init();
      }
      if (attempts > 30) { clearInterval(iv); init(); }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSlick);
  } else {
    waitForSlick();
  }

})();
